module.exports = __webpack_public_path__ + "img/34bf0d0.jpg";